import { EnumQuotationStatus, IQuotationPriceInfo, EnumQuotationValueType, EnumQuotationItemInfoOption } from '@simplyfly/shared';
export const getQuotationStatusLabel = (status: EnumQuotationStatus): string => {
  switch (status) {
    default:
      return status;
    case EnumQuotationStatus.draft:
      return 'QUOTATION.STATUSES.DRAFT';
    case EnumQuotationStatus.rejected:
      return 'QUOTATION.STATUSES.REJECTED';
    case EnumQuotationStatus.confirmed:
      return 'QUOTATION.STATUSES.CONFIRMED';
    case EnumQuotationStatus.sent:
      return 'QUOTATION.STATUSES.SENT';
  }
};

export const isPriceInfoEligibleForVatBase = (
  priceInfo: IQuotationPriceInfo | null | undefined
): boolean => {
  if (!priceInfo) {
    return false;
  }

  if (![EnumQuotationValueType.price, EnumQuotationValueType.tsba].includes(priceInfo.type)) {
    return false;
  }

  return priceInfo.optionSelected === EnumQuotationItemInfoOption.priceAmount;
};

export const getQuotationItemInfoOptionLabel = (option: EnumQuotationItemInfoOption): string => {
  switch (option) {
    default:
      return option;
    case EnumQuotationItemInfoOption.exempted:
      return 'QUOTATION.ITEMS.OPTIONS.EXEMPTED';
    case EnumQuotationItemInfoOption.included:
      return 'QUOTATION.ITEMS.OPTIONS.INCLUDED';
    case EnumQuotationItemInfoOption.uponRequest:
      return 'QUOTATION.ITEMS.OPTIONS.UPON_REQUEST';
    case EnumQuotationItemInfoOption.other:
      return 'QUOTATION.ITEMS.OPTIONS.OTHER';
    case EnumQuotationItemInfoOption.cateringStandard:
      return 'QUOTATION.ITEMS.OPTIONS.CATERING_STANDARD';
    case EnumQuotationItemInfoOption.cateringVip:
      return 'QUOTATION.ITEMS.OPTIONS.CATERING_VIP';
    case EnumQuotationItemInfoOption.yes:
      return 'QUOTATION.ITEMS.OPTIONS.YES';
    case EnumQuotationItemInfoOption.no:
      return 'QUOTATION.ITEMS.OPTIONS.NO';
    case EnumQuotationItemInfoOption.vatExempted:
      return 'QUOTATION.ITEMS.OPTIONS.VAT_EXEMPTED';
    case EnumQuotationItemInfoOption.vatFivePercent:
      return 'QUOTATION.ITEMS.OPTIONS.VAT_FIVE_PERCENT';
    case EnumQuotationItemInfoOption.vatTenPercent:
      return 'QUOTATION.ITEMS.OPTIONS.VAT_TEN_PERCENT';
    case EnumQuotationItemInfoOption.vatTwentyPercent:
      return 'QUOTATION.ITEMS.OPTIONS.VAT_TWENTY_PERCENT';
    case EnumQuotationItemInfoOption.priceAmount:
      return 'QUOTATION.ITEMS.OPTIONS.PRICE_AMOUNT';
  }
};
